
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.368 2.346a.75.75 0 00-.736 0L3.642 6.84a.746.746 0 00-.294.29l-.002.002-.002.005m-.094.376V16.5c0 .271.146.52.382.654l7.989 4.493a.747.747 0 00.758 0l7.989-4.493a.75.75 0 00.382-.654V7.513a.747.747 0 00-.393-.673l-7.99-4.494M4.75 8.782v7.28l6.5 3.656v-7.28l-6.5-3.656zM12 11.14L18.47 7.5 12 3.86 5.53 7.5 12 11.14zm7.25 4.922l-6.5 3.657v-7.28l6.5-3.656v7.28z"}})])
          )
        }
      }
    